import React from 'react';

/*
HOC to add error display to a component, includes error class
wrapper and displays error message beneath component.
Accepts error array of format:
errors: [
  {
    msg: String,
    severity: String (e.g. "warning" or "error")
  }
]
*/
const withError = WrappedComponent => props => {
    if (!props.error) {
        return <WrappedComponent {...props} />;
    }
    const {error, ...componentProps} = props;
    return (
        <div className="otp-has-error">
            <WrappedComponent {...componentProps} />
            <div className="otp-component-error">
                {error.msg}
            </div>
        </div>
    );
};

export default withError;